import React from 'react';
import VoiceToTextTextarea from '@components/VoiceToTextTextarea';
import getVoiceToTextBlockedMessages from './VoiceTranscribing/utils';
import { AboutMeTypes } from '../StepThreeTypes';

interface KnowAboutMeProps {
  aboutMe: AboutMeTypes;
  setAboutMe: (aboutMe: AboutMeTypes) => void;
}

const KnowAboutMe: React.FC<KnowAboutMeProps> = ({ aboutMe, setAboutMe }) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="know-about-me">
          Also worth knowing about me
        </label>
      </h1>
      <div className="govuk-body">
        A description of what is also worth knowing about you for people caring
        or supporting you. This could include a short history of your life
        (where you have worked, where you lived, important events in your life,
        important people in your past life).
      </div>
      <div className="govuk-body">
        This could include a short profile of your current life:- your work /
        study, your aspirations, your skills, your networks, things you like
        e.g. particular foods, places, a football team and things you like to
        talk about, things you dislike This could also include any care and
        support preferences that have not been included elsewhere.
      </div>

      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">Prompt questions</span>
        </summary>
        <div className="govuk-details__text">
          <ol className="govuk-list govuk-list--number">
            <li>
              <div className="govuk-body">
                Provide a short summary of your past life. Think about: where
                you worked, what jobs you have had. where you lived. important
                people in your life. important events in your life
              </div>
            </li>
            <li>
              <div className="govuk-body">
                Provide a short profile of your current life. Think about: where
                you work, your job or college. your strengths and skills. your
                networks. exercise.
              </div>
            </li>
            <li>
              <div className="govuk-body">
                What do you like to do? Think about people you like to see,
                places you like to visit, activities you enjoy doing and your
                favourite tv programmes etc.
              </div>
            </li>
            <li>
              <div className="govuk-body">
                What are your food preferences or requirements?
              </div>
            </li>
            <li>
              <div className="govuk-body">What do you like to talk about?</div>
            </li>
            <li>
              <div className="govuk-body">
                What do you not like? Think about environments you do not like
                to be in, food, places, things you do not like to do and things
                you do not like to talk about.
              </div>
            </li>
          </ol>
        </div>
      </details>

      <VoiceToTextTextarea
        id="know-about-me"
        name="knowAboutMe"
        value={aboutMe.knowAboutMe || ''}
        rows={5}
        autoComplete="knowAboutMe"
        placeholder="Type here or use voice to text..."
        recordBlockedErrors={getVoiceToTextBlockedMessages(aboutMe)}
        onChange={value => setAboutMe({ ...aboutMe, knowAboutMe: value })}
      />
    </div>
  );
};

export default KnowAboutMe;
